import React from 'react';
import { Box, Typography, Container } from '@mui/material';

const PrivacyPolicy = () => {
  return (
    <Container maxWidth="md" sx={{ my: 4 }}>
      <Box>
        <Typography variant="h4" gutterBottom fontWeight="bold" textTransform="uppercase">
          Privacy Policy
        </Typography>

        <Typography variant="body1" paragraph>
          At BizStor, your privacy is important to us. This Privacy Policy describes how we collect, use, and protect your
          information when you use our platform. By accessing or using BizStor, you agree to the practices described in this policy.
        </Typography>

        <Typography variant="h6" gutterBottom>
          1. Information We Collect
        </Typography>
        <Typography variant="body1" paragraph>
          When you use BizStor, we may collect the following types of information:
        </Typography>
        <ul>
          <li><strong>Personal Information:</strong> Name and email address (collected through Google OAuth sign-in).</li>
          <li><strong>Usage Data:</strong> Details about how you use the platform, including login activity, features accessed, and device/browser information.</li>
        </ul>

        <Typography variant="h6" gutterBottom mt={2}>
          2. How We Use Your Information
        </Typography>
        <Typography variant="body1" paragraph>
          We use the collected information to:
        </Typography>
        <ul>
          <li>Provide and maintain core functionalities such as invoicing, inventory, and expense tracking.</li>
          <li>Generate business reports and dashboards.</li>
          <li>Improve and enhance user experience and platform performance.</li>
          <li>Communicate important updates, support responses, or service-related notifications.</li>
        </ul>

        <Typography variant="h6" gutterBottom mt={2}>
          3. Google OAuth Registration
        </Typography>
        <Typography variant="body1" paragraph>
          BizStor supports Google OAuth for quick and secure registration/login. We access your Google account's name and email
          only to create and manage your BizStor account. We do not store your Google password or access any other private data.
        </Typography>

        <Typography variant="h6" gutterBottom mt={2}>
          4. Data Security
        </Typography>
        <Typography variant="body1" paragraph>
          We implement industry-standard encryption protocols, secure server infrastructure, and regular audits to protect your data.
          Unauthorized access, loss, or misuse of your information is actively prevented with these measures.
        </Typography>

        <Typography variant="h6" gutterBottom mt={2}>
          5. Sharing Your Information
        </Typography>
        <Typography variant="body1" paragraph>
          We do not sell, rent, or share your personal information with third parties, except:
        </Typography>
        <ul>
          <li>If required by law, legal process, or government request.</li>
          <li>To protect the safety and integrity of our platform and users.</li>
        </ul>

        <Typography variant="h6" gutterBottom mt={2}>
          6. Your Choices and Rights
        </Typography>
        <Typography variant="body1" paragraph>
          You have the right to:
        </Typography>
        <ul>
          <li>Access and review the personal data associated with your account.</li>
          <li>Update or correct your information at any time.</li>
          <li>Request deletion of your account and related data.</li>
        </ul>

        <Typography variant="h6" gutterBottom mt={2}>
          7. Changes to This Privacy Policy
        </Typography>
        <Typography variant="body1" paragraph>
          We may revise this Privacy Policy periodically. Significant changes will be communicated via email or in-app notifications.
          The "Last Updated" date at the top of this policy reflects the latest revision.
        </Typography>

        <Typography variant="h6" gutterBottom mt={2}>
          8. Contact Us
        </Typography>
        <Typography variant="body1" paragraph>
          If you have questions, concerns, or requests regarding this Privacy Policy, please contact us at: <strong>support@bizstor.lk</strong>
        </Typography>
        <Typography variant="body1" paragraph>
                  Last update: <strong>2026-07-14</strong>
                </Typography>
      </Box>
    </Container>
  );
};

export default PrivacyPolicy;
